import NiceModal, { useModal } from '@ebay/nice-modal-react';
import { Modal, Overlay, ScrollArea } from '@mantine/core';

import { useEditBotPage } from '../../api/editPage';
import { botTypes } from '../../types';

import { PageForm } from './PageForm';

export const EditModal = NiceModal.create(({ page }: { page: botTypes.Page }) => {
  const modal = useModal();
  const {
    _id,
    name,
    externalId,
    department,
    appPages,
    subDepartment,
    isExpert,
    isMandatoryManagerSelect,
  } = page;

  const editBotPage = useEditBotPage({
    config: { onSuccess: modal.hide },
  });

  return (
    <Modal
      title={name}
      centered
      overlayProps={{ opacity: 0.4, blur: 1.5 }}
      opened={modal.visible}
      onClose={modal.remove}
      closeOnEscape={!editBotPage.isLoading}
      closeOnClickOutside={!editBotPage.isLoading}
      withCloseButton={!editBotPage.isLoading}
      scrollAreaComponent={ScrollArea.Autosize}
    >
      {editBotPage.isLoading && <Overlay opacity={0} />}
      <PageForm
        onSubmit={(data) => editBotPage.mutate({ ...data, _id })}
        isLoading={editBotPage.isLoading}
        isEdit
        initialValues={{
          name,
          externalId,
          department,
          appPages,
          subDepartment,
          isExpert,
          isMandatoryManagerSelect,
        }}
      />
    </Modal>
  );
});
